import script from "./step.vue?vue&type=script&setup=true&lang=js"
export * from "./step.vue?vue&type=script&setup=true&lang=js"

import "./step.vue?vue&type=style&index=0&id=ab118cbc&lang=less&scoped=true"

import exportComponent from "/usr/share/nginx/html/vue_saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab118cbc"]])

export default __exports__